import { render, staticRenderFns } from "./ficheDossier.vue?vue&type=template&id=670d66d1"
import script from "./ficheDossier.vue?vue&type=script&lang=js"
export * from "./ficheDossier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports